export default __webpack_public_path__ + "static/media/107.f466085c.webp";